export enum Role {
  MASTER = 'MASTER',
  ADMIN = 'ADMIN',
  SETTLE_MANAGER = 'SETTLE_MANAGER'
}
export const ROLE = {
  [Role.MASTER]: '관리자',
  [Role.ADMIN]: '운영자',
  [Role.SETTLE_MANAGER]: '정산담당자'
} as const;

export const ALL_ROLES = Object.values(Role);
export const SETTLEABLE_ROLES = [Role.MASTER, Role.SETTLE_MANAGER];
export const CONTRACT_MANAGABLE_ROLES = [Role.MASTER, Role.ADMIN];
export const PARTNER_MANAGABLE_ROLES = [Role.MASTER, Role.ADMIN];
